import { useEffect } from 'react';

import { isOpendoorAppEvoWebView, sendWebViewLinkEvent } from 'src/helpers/webview';

const interceptLinks = (e: MouseEvent) => {
  if (e.target) {
    const target = e.target as Element;
    const linkTag = target.closest('a');
    const href = linkTag?.getAttribute('href');
    if (href) {
      const url = new URL(href, document.location.href);

      // Have the native app handle the click rather than this web view
      e.preventDefault();
      sendWebViewLinkEvent(url);
    }
  }
};

/** Intercepts href links and sends a message to the mobile webview */
export const useWebViewLinkIntercept = () => {
  useEffect(() => {
    if (isOpendoorAppEvoWebView) {
      document.addEventListener('click', interceptLinks);

      return () => document.removeEventListener('click', interceptLinks);
    }
  }, []);
};
